




































































































































































































interface NavList {
    name: string;
    dataList: string;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import SideNavVue from "../components/SideNav.vue";
import ChooseAssitVue from "../components/ChooseAssit.vue";
import ChooseSubjectVue from "../components/ChooseSubject.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import version from "@/version";

@Component({
    components: {
        "side-nav": SideNavVue,
        "choose-assit": ChooseAssitVue,
        "choose-subject": ChooseSubjectVue,
        "month-selector": MonthSelectorVue,
    },
})
export default class DimAssitSub extends Vue {
    @Prop({ type: Array })
    tableData!: any[];

    @Prop({ type: Array })
    period!: string[];

    @Prop({ type: Object })
    assistVal: any;

    @Prop({ type: Object })
    subjectVal: any;

    // 下载
    id: number | string = "";
    downLoad() {
        if (this.assistVal) {
            if (this.assistVal.id) this.id = this.assistVal.id;
        }
        let subId = "";
        if (this.subjectVal) {
            if (this.subjectVal.id) subId = this.subjectVal.id;
        }
        let dimAccountId = this.id || "";
        let url = `${
            Vue.axios.defaults.baseURL
        }export/subsidiaryledger/dim/num?accountBookId=${
            this.$store.state.accountBook.id
        }&subjectId=${subId}&dimAccountType=${"存货"}&dimAccountId=${dimAccountId}&startPeriod=${
            this.period[0]
        }&endPeriod=${this.period[1]}&token=${
            this.$store.state.account.token
        }&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }

    pdfDownLoad() {
        if (this.assistVal) {
            if (this.assistVal.id) this.id = this.assistVal.id;
        }
        let subId = "";
        if (this.subjectVal) {
            if (this.subjectVal.id) subId = this.subjectVal.id;
        }
        let dimAccountId = this.id || "";
        let url = `${
            Vue.axios.defaults.baseURL
        }export/pdf/subsidiaryledger/dim/num?accountBookId=${
            this.$store.state.accountBook.id
        }&subjectId=${subId}&dimAccountType=${"存货"}&dimAccountId=${dimAccountId}&startPeriod=${
            this.period[0]
        }&endPeriod=${this.period[1]}&token=${
            this.$store.state.account.token
        }&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
}
